const ADD_WEBHOOK = {
  ADD_PAGE_HEADER_TITLE: 'وب هوک',
  ADD_PAGE_HEADER_DESCRIPTION:
    'وب‌هوک به شما اجازه می‌دهد تا اعلان‌ها را به طور خودکار از رایچت به اپلیکیشن خود ارسال کنید. با استفاده از وب‌هوک، پیام‌ها و درخواست‌های کاربران را دریافت و از آنها بهره‌برداری کنید.',

  ADD_PAGE_WEBSITE_TITLE: 'انتخاب وبسایت',
  ADD_PAGE_WEBSITE_SELECT_TITLE: 'وبسایت',

  ADD_PAGE_ADDRESS_INPUT_TITLE: 'آدرس وب هوک خود را وارد نمایید',
  ADD_PAGE_ADDRESS_INPUT_PLACEHOLDER: 'آدرس   https://example.com',
  ADD_PAGE_ADDRESS_INPUT_DESCRIPTION: `آدرس وب‌هوک خود را وارد کنید. در صورت نیاز، آدرس را به صورت percent-encoded وارد نمایید. مثال: https://example.com`,
  ADD_PAGE_TOKEN_TITLE: 'توکن اختصاصی (اختیاری)',
  ADD_PAGE_TOKEN_OPTIONAL_NOTE: 'اختیاری',
  ADD_PAGE_TOKEN_DESC:
    'این توکن در header با کلید X-Raychat-Token به درخواست‌ها اضافه می‌شود. می‌توانید از آن برای اعتبارسنجی داده‌های دریافتی استفاده کنید.',
  ADD_PAGE_TOKEN_INPUT_PLACEHOLDER: 'وارد نمایید',
  ADD_PAGE_EVENTS_TITLE: 'رویدادها',
  ADD_PAGE_EVENTS_DESC:
    'در این بخش، می‌توایند انتخاب کنید که مایل به دریافت کدام نوع داده‌ها هستید.',
  ADD_PAGE_EVENTS_NEW_MSG_LABEL: 'پیام جدید',
  ADD_PAGE_EVENTS_NEW_CONV_LABEL: 'مکالمه جدید',

  ADD_PAGE_EDIT_BTN_LABEL: 'ویرایش وب هوک',
  ADD_PAGE_ADD_BTN_LABEL: 'ایجاد وب هوک',

  ADD_PAGE_EMPTY_ADDRESS_ERROR: 'لطفا آدرس وب هوک را وارد نمایید',
  ADD_PAGE_INVALID_ADDRESS: "'آدرس وب هوک نامعتبر است'",
  ADD_PAGE_ADDRESS_PROTOCOL_ERROR: 'تنها پروتکل HTTPS مورد قبول است',
  ADD_PAGE_EVENT_TYPE_NOT_SELECTED: 'انتخاب حداقل یکی از رویدادها الزامیست',
};

export default ADD_WEBHOOK;
